import ModalSelectProductDialog from "features/Campaign/components/CampaignForm/Form/OneOnProductForm/ModalSelectProduct/ModalSelectProductDialog";
import useModalSelectProduct from "features/Campaign/components/CampaignForm/Form/OneOnProductForm/ModalSelectProduct/useModalSelectProduct";
import { LOYALTY_APPLY_SCOPE } from "features/LoyaltyPackage/core/constants";
import "features/Campaign/components/CampaignForm/Form/OneOnProductForm/ModalSelectProduct/index.scss";

function ProductSelectModal({ visible, categoryId, applyScope, selectedProductIds, onCancel, onConfirm }) {
  const isSingleSelect = applyScope === LOYALTY_APPLY_SCOPE.SINGLE_PRODUCT;

  const hookState = useModalSelectProduct({
    loyaltyConfig: {
      visible,
      lockedCategoryId: categoryId,
      excludeProductIds: selectedProductIds,
      singleSelect: isSingleSelect,
      onConfirm,
    },
  });

  return (
    <ModalSelectProductDialog
      visible={visible}
      closable
      onCancel={onCancel}
      onConfirm={hookState.handleSelectProduct}
      showTrigger={false}
      lockCategoryFilter={Boolean(categoryId)}
      selectionType={isSingleSelect ? "radio" : "checkbox"}
      hookState={hookState}
    />
  );
}

export default ProductSelectModal;
